//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';

export default {
  name: "plan-info",
  props: ['view'],
  data() {
    return {
      cargoDto: {},
      cargoId: null,
      userType: null,
      editable: false
    }
  },
  mounted() {
    this.cargoId = this.$route.params.id;
    this.getContractItemDto();
    this.userType = this.$store.userType;
  },
  methods: {
    getContractItemDto() {
      this.$get('api/requireGoodsOrder/' + this.cargoId).then((data) => {
        this.cargoDto = data;
        this.editable = (data.state === 'confirming');
        if(this.cargoDto.requireGoodsOrderDts){
          this.cargoDto.requireGoodsOrderDts.forEach((dto) => {
            dto.requireGoodsOrderDtRows.forEach((item) => {
              if(item.planType === 'confirm') {
                if (!item.confirmCount) {
                  item.confirmCount = item.planCount;
                }
              }
            })
          })
        }
      })
    },
    changeSup(requireGoodsOrderDt) {
      if (requireGoodsOrderDt.show) {
        this.$set(requireGoodsOrderDt, 'show', false);
        return;
      }
      this.$set(requireGoodsOrderDt, 'show', true);
    },
    switchTabItem(e, info) {
      e['list'] = info;
      this.$forceUpdate();
    }
  },
  components: {
    DivSpan
  }
}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/view/plan-info.vue